













































































































































import Vue from 'vue'
import BaseIcon from '@/components/svgicons/BaseIcon.vue'
import Editor from '@tinymce/tinymce-vue'
import ReplyCommentModal from './ReplyCommentModal.vue'
import { CommentService } from '@/services/'
import { editorConfig } from '@/helper/constants'
import { getUserId } from '@/services/'
import { COMMENT_MAX_LENGTH } from '@/helper/constants'

import moment from 'moment'
import {
    Dropdown,
    DropdownMenu,
    DropdownItem
} from 'view-design'
export default Vue.extend({
    name: "OneComment",
    data() {
      return {
        editingComment: false,
        contentText: "",
        replyComment: false,
        privacyOptionList: [{
          label: "Public",
          value: "public",
          svgicon: "globealt"
        }, {
          label: "Instructor Only",
          value: "private",
          svgicon: "lockclosed"
        }],
        currentPrivacyOption: {
          label: "Instructor Only",
          value: "private",
          svgicon: "lockclosed"
        },
        showReplies: true
      }
    },
    mounted() {
      this.setcurrentPrivacyOption()
    },
    components: {
        BaseIcon,
        Dropdown,
        DropdownMenu,
        DropdownItem,
        ReplyCommentModal,
        editor: Editor
    },
    props: {
        content: {
            type: String
        },
        id: {
            type: String
        },
        commentElem: {
          type: Object
        },
        instructor: {
          type: Object
        },
        commentPermission: {
          type: String
        },
        pendoPayload: {
          type: Object
        }
    },
    methods: {
        hideReplyList() {
          this.showReplies = !this.showReplies
          this.$emit("hideReplyList", this.showReplies)
        },
        closeReplyModal() {
          this.replyComment = false
        },
        startEditComment() {
          this.contentText = this.content
          this.editingComment = true    
        },
        cancelUpdate() {
          this.editingComment = false
          this.contentText = this.content
        },
        async deleteComment() {
          await CommentService.deleteComment(this.id)
          if (this.isParentComment === true) {
            this.$bus.$emit("deleteStateParentComment", { id: this.id })
          } else {
            this.$bus.$emit("deleteStateChildComment", { id: this.id, parentCommentId: this.commentElem.parentCommentId })
          }
        },
        updateComment() {
          this.editingComment = false
          this.$bus.$emit('updateComment', { id: this.id, content: this.contentText })
          if (this.isParentComment === true) {
            this.$emit("updateStateParentComment", { id: this.id, content: this.contentText })
          } else {
            this.$emit("updateStateChildComment", { id: this.id, content: this.contentText })
          }
        },
        setcurrentPrivacyOption() {
          const option = this.privacyOptionList.find(elem => {
            return elem.value === this.commentElem.visibility
          })

          if (option !== undefined){ 
            this.currentPrivacyOption = option
          }
        }
    },
    computed: {
      showEditDeleteDropdown() {
        return this.currentUserId && (this.commentElem.userId === this.currentUserId)
      },
      currentUserId() {
        return getUserId()
      },
      hasReplies() {
        return this.commentElem && this.commentElem.replies && this.commentElem.replies.length > 0 
      },
      commentCharacterLength() {
        return COMMENT_MAX_LENGTH || 140
      },
      postButtonDisabled() {
        return this.replyTextLength > this.commentCharacterLength || this.replyTextLength === 0
      },
      replyTextLength() {
        return this.contentText.replace(/<\/?[^>]+(>|$)/g, "").replace(/&nbsp;/g, ' ').length
      },
      editorConfig() {
        return editorConfig
      },
      timeSince() {
        return moment(this.commentElem.createdAt).fromNow()
      },
      isParentComment() {
        return this.commentElem.parentCommentId === null || this.commentElem.parentCommentId === undefined
      },
      parentCommentId() {
        if (this.isParentComment === true) {
          return this.id
        } else {
          return this.commentElem.parentCommentId
        }
      },
      repliedToText() {
        const currentCommenterUserDetails = this.commentElem.replyUserDetails
        return `Replied to: ${currentCommenterUserDetails ? currentCommenterUserDetails.name : "Instructor"}: <span class="cursor-default text-blue-600">${this.commentElem.repliedToComment?.replace(/<\/?[^>]+(>|$)/g, "").substring(0, 50)}</span>`
      }
    }
})
